import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { applicationTabSelected, notesListSelector, notesTotalCount } from "../../../store/selectors/application";
import { applicationSetTabAction } from "../../../store/actions/application";
var tabSelectorProps = createStructuredSelector({
  selected_tab: applicationTabSelected,
  notes: notesListSelector,
  note_count: notesTotalCount
});
var tabSelectorDispatch = function tabSelectorDispatch(dispatch) {
  return {
    set_tab: function set_tab(tab_name) {
      var _window;
      dispatch(applicationSetTabAction(tab_name));
      var history = (_window = window) === null || _window === void 0 ? void 0 : _window.history;
      if (history) {
        var pathname = window.location.pathname;
        var applicationsPath = pathname.match(/\/applications\/(\d+)/);
        if (!applicationsPath) return;
        var applicationId = applicationsPath[1];
        var urlTabName = tab_name.toLowerCase().replace(/ /g, '-');
        var nextLocation = urlTabName === 'admin-requirements' || urlTabName === 'notes' || urlTabName === 'admin-comments' ? "".concat(window.location.origin, "/applications/").concat(applicationId, "/").concat(urlTabName) : "".concat(window.location.origin, "/applications/").concat(applicationId, "?tab=").concat(urlTabName);
        history.pushState({}, '', nextLocation);
      }
    }
  };
};
var tabSelectorEnhancer = connect(tabSelectorProps, tabSelectorDispatch);
export default tabSelectorEnhancer;